<template>
    <div>
        <v-text-field label="Título" v-model="ctn.items.title" :disabled="!enabled"></v-text-field>
        <v-text-field label="Sub-título" v-model="ctn.items.subtitle" :disabled="!enabled"></v-text-field>
    </div>
</template>

<script>
export default {
    props: [ 'disabled' ],
    data: function() {
        return {
            ctn: {
                items: {
                    title: '',
                    subtitle: ''
                }
            },
            enabled: true
        }
    },
    // watch: {
    //     'ctn.items.title': function() {
    //         this.updateValue();
    //     },
    //     'ctn.items.subtitle': function() {
    //         this.updateValue();
    //     }
    // },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        if(this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        }
    }
}
</script>

